export { default as WhyDeliver } from './WhyDeliver'
export { default as Cities } from './Cities'
export { default as Footer } from './Footer'
export { default as SelectMarket } from './SelectMarket'
export { default as SignUpStep1 } from './SignUpStep1'
export { default as SignUpStep2 } from './SignUpStep2'
export { default as Testimonials } from './Testimonials'
export { default as DownloadApp } from './DownloadApp'
export { default as ByTexans } from './ByTexans'
export { default as Heb } from './Heb'
export { default as BackToTop } from './BackToTop'
export { default as Faq } from './Faq'
export { default as PayBreakdown } from './PayBreakdown'
export { default as ShopAndDeliver } from './ShopAndDeliver'
